var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mt-10" },
    [
      _c(
        "md-card",
        [
          _c(
            "md-card-expand",
            [
              _c(
                "md-card-actions",
                { attrs: { "md-alignment": "space-between" } },
                [
                  _c(
                    "md-card-expand-trigger",
                    [
                      _c("md-button", { staticClass: "expand-button-size" }, [
                        _c("strong", [
                          _vm._v("Emails "),
                          _c("span", [
                            _vm._v("(" + _vm._s(_vm.emails.length) + ")")
                          ])
                        ])
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "md-card-expand-content",
                [
                  _c("md-card-content", { staticClass: "comments" }, [
                    _c(
                      "div",
                      { staticClass: "email-log" },
                      _vm._l(_vm.emails, function(email, index) {
                        return _c(
                          "div",
                          { key: email._id, staticClass: "email" },
                          [
                            email.sentstatus == "Sent"
                              ? _c(
                                  "span",
                                  { staticStyle: { color: "green" } },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(_vm.formatDate(email.sentAt)) +
                                        "\n\t\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            email.sentstatus != "Sent"
                              ? _c("span", { staticStyle: { color: "red" } }, [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t" +
                                      _vm._s(_vm.formatDate(email.errorAt)) +
                                      " : " +
                                      _vm._s(email.sentstatus) +
                                      "\n\t\t\t\t\t\t\t"
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("b", [_vm._v(_vm._s(email.subject))]),
                            _vm._v(" " + _vm._s(email.to) + "\n\t\t\t\t\t\t\t"),
                            _c(
                              "span",
                              { staticStyle: { "font-size": "8px" } },
                              [
                                _vm._v(
                                  "(" + _vm._s(index) + ") " + _vm._s(email._id)
                                )
                              ]
                            )
                          ]
                        )
                      }),
                      0
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-40c1c638", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40c1c638","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EmailLog.vue
// module id = null
// module chunks = 